import React from 'react';
import styled from 'styled-components';
import { format as formatDate } from 'date-fns';

import Monthpicker from './Component';
import { Container, TextInput } from 'ui/components/styled';
import { spacing } from 'ui/theme/utils';

export const MonthPicker = ({
  month,
  year,
  format = 'MMM yyyy',
  width = '200px',
  placeholder = 'Choose a date',
  onChange,
  ...rest
}) => {
  const value = React.useMemo(() => formatDate(new Date(year, month - 1), format), [month, year]);

  return (
    <Monthpicker month={month} year={year} onChange={onChange}>
      <RelativeContainer {...rest} width={width} height="auto">
        <CalendarIcon />
        <TextInput
          variant="minimal"
          textAlign="center"
          cursor="pointer"
          px="40px"
          placeholder={placeholder}
          value={value}
          onChange={() => {}}
          readOnly
        />
      </RelativeContainer>
    </Monthpicker>
  );
};

const RelativeContainer = styled(Container)`
  position: relative;
  ${(props) => spacing(props)}
`;

const CalendarIcon = styled.img.attrs(() => ({
  src: '/assets/img/icons/calendar.svg',
  alt: 'calendar',
}))`
  position: absolute;
  top: 8px;
  left: 10px;
  width: 18px;
  pointer-events: none;
`;
